import { State } from '../reducers/rootReducer'

const excludedPartsSelector = (state: State): string[] => state.excludeAudiExclusiveSelection

export default excludedPartsSelector
